import React from 'react';
import { TextField, Button } from 'components/ui';
import { Formik } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { WideForm } from 'components/styles_components/form';
import validationSchema from 'validation/user/two_factor_verification';

const VerificationForm = ({
  initialValues,
  onSubmit,
  processing,
  submitLabel = <FormattedMessage id="button.login" />,
}) => {
  const intl = useIntl();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema(intl)}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, handleChange, handleBlur, values, touched, errors, isValid }) => (
        <WideForm onSubmit={handleSubmit}>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            id="code"
            name="code"
            label={intl.formatMessage({ id: 'verification.code' }) + ' *'}
            value={values.code}
            onChange={handleChange}
            onBlur={handleBlur}
            error={(values.code && touched.code && Boolean(errors.code)) || undefined}
            helperText={values.code && touched.code && errors.code}
          />
          <Button
            fullWidth
            disabled={processing || !isValid}
            color="primary"
            variant="contained"
            type="submit"
          >
            {submitLabel}
          </Button>
        </WideForm>
      )}
    </Formik>
  );
};

export default VerificationForm;
